/*
 *  For adding a progress bar at top of wizard for responsive view
 *
 */

import _WizardStepsCtrl from './_WizardStepsCtrl';
import templateStr from 'text!./templates/wizard-step-progress.html';

export default function () {
    return {
        restrict: 'A',
        replace: true,
        template: templateStr,
        require: '^gwNavBarWizardBase',
        controller: _WizardStepsCtrl,
        link: function link(scope, element, attrs, navBarWizardBaseCtrl) {
            scope.toggleWizardStepDisplay = function () {
                navBarWizardBaseCtrl.toggleSideBarMenu();
            };
        }
    };
}


//////////////////
// WEBPACK FOOTER
// ./app/customer/js/src/edge/platform/widgets/wizard/WizardStepProgressDirective.js
// module id = 793
// module chunks = 0